(() => {
  if (window.__callieFavoritesV4) return;
  window.__callieFavoritesV4 = true;
  const KEY = 'callieLeeFavorites';
  const root = window.Shopify?.routes?.root || '/';
  const selector = '.cl-favorite-btn, [data-callie-favorite], callie-favorite button';
  const handleOf = item => typeof item === 'string' ? item : item?.handle;
  function read() {
    const value = JSON.parse(localStorage.getItem(KEY) || '[]');
    if (!Array.isArray(value)) throw new Error('Invalid favorites data');
    return value;
  }
  function notify(items) {
    document.dispatchEvent(new CustomEvent('callie:favorites-changed', { detail: { items, count: items.length } }));
    document.dispatchEvent(new CustomEvent('callieLeeFavoritesUpdated', { detail: { favorites: items.map(handleOf) } }));
  }
  function save(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    notify(items);
  }
  function refresh() {
    let items;
    try { items = read(); } catch (_) { return; }
    const handles = new Set(items.map(handleOf));
    document.querySelectorAll(selector).forEach(button => {
      const host = button.closest('callie-favorite');
      const handle = host?.dataset.handle || button.dataset.productHandle;
      const active = handles.has(handle);
      button.classList.toggle('is-favorite', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Remove from favorites' : 'Add to favorites');
      /* Use the same true heart outline on cards, quick views and stack tiles. */
      const svg = button.querySelector('svg');
      if (svg && !svg.dataset.clClassicShape) {
        const paths = svg.querySelectorAll('path');
        if (paths.length === 1) {
          svg.setAttribute('viewBox', '0 0 24 24');
          svg.setAttribute('stroke-linecap', 'round');
          svg.setAttribute('stroke-linejoin', 'round');
          svg.setAttribute('stroke-width', '1.7');
          paths[0].setAttribute('d', 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78Z');
        }
        svg.dataset.clClassicShape = 'true';
      }
      button.querySelectorAll('svg, svg path').forEach(icon => {
        icon.style.setProperty('fill', active ? '#111111' : 'none', 'important');
        icon.style.setProperty('stroke', '#111111', 'important');
      });
      if (host) {
        host.style.top = '2px';
        host.style.right = '2px';
        button.style.setProperty('width', '34px', 'important');
        button.style.setProperty('height', '34px', 'important');
        button.style.setProperty('min-width', '34px', 'important');
        button.style.setProperty('min-height', '34px', 'important');
        button.style.setProperty('padding', '6px', 'important');
        const svg = button.querySelector('svg');
        if (svg) {
          svg.style.setProperty('width', '17px', 'important');
          svg.style.setProperty('height', '17px', 'important');
        }
      }
    });
    document.querySelectorAll('[data-favorites-count], [data-callie-favorites-count]').forEach(el => {
      el.textContent = items.length;
      el.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-clm-favorites-link]').forEach(link => {
      link.classList.toggle('is-favorites-page', /\/pages\/favorites\/?$/.test(window.location.pathname));
    });
  }
  async function details(handle) {
    const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js');
    if (!response.ok) throw new Error('Product unavailable');
    const product = await response.json();
    const currency = window.Shopify?.currency?.active || document.documentElement.dataset.currency;
    let price = '';
    if (currency) {
      try {
        price = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(product.price / 100);
      } catch (_) { /* Leave price blank if currency cannot be formatted. */ }
    }
    return { handle, title: product.title, url: root + 'products/' + encodeURIComponent(handle), image: product.featured_image || '', price };
  }
  let queue = Promise.resolve();
  async function migrate() {
    let original;
    try { original = read(); } catch (_) { return; }
    const replacements = new Map();
    await Promise.all(original.filter(item => typeof item === 'string' || item?._needsDetails).map(async item => {
      const handle = handleOf(item);
      if (!handle) return;
      try { replacements.set(handle, await details(handle)); }
      catch (_) {
        replacements.set(handle, { handle, title: handle.replace(/-/g, ' '), url: root + 'products/' + encodeURIComponent(handle), image: '', price: '', _needsDetails: true });
      }
    }));
    if (!replacements.size) return;
    try {
      // Read again so a favorite removed during loading stays removed.
      const current = read();
      const items = current.map(item => (typeof item === 'string' || item?._needsDetails) ? replacements.get(handleOf(item)) || item : item);
      save(items);
    } catch (_) { /* Preserve saved data if storage is unavailable. */ }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest(selector);
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const host = button.closest('callie-favorite');
    const handle = host?.dataset.handle || button.dataset.productHandle;
    if (!handle || button.disabled) return;
    button.disabled = true;
    queue = queue.then(async () => {
      try {
        let items = read();
        const active = items.some(item => handleOf(item) === handle);
        if (active) items = items.filter(item => handleOf(item) !== handle);
        else {
          const item = host ? {
            handle, title: host.dataset.title, url: host.dataset.url,
            image: host.dataset.image, price: host.dataset.price
          } : await details(handle);
          // Re-read after the request to retain changes made elsewhere.
          items = read();
          if (!items.some(item => handleOf(item) === handle)) items.push(item);
        }
        save(items);
        const status = host?.querySelector('[role="status"]');
        if (status) status.textContent = active ? 'Removed from favorites.' : 'Saved to favorites.';
      } catch (_) {
        alert('Your favorite could not be saved. Please try again and check that browser storage is allowed.');
      } finally { button.disabled = false; refresh(); }
    });
  }, true);
  document.addEventListener('callie:favorites-changed', refresh);
  document.addEventListener('callieLeeFavoritesUpdated', refresh);
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('storage', event => {
    if (event.key === KEY || event.key === null) { refresh(); queue = queue.then(migrate); }
  });
  // Filters and load-more can insert cards without reloading the document.
  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (scheduled || !records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.(selector + ', callie-favorite, [data-callie-favorites-count], [data-favorites-count], [data-clm-favorites-link]') || node.querySelector?.(selector + ', [data-callie-favorites-count], [data-favorites-count], [data-clm-favorites-link]'))))) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  });
  function init() {
    refresh();
    observer.observe(document.body, { childList: true, subtree: true });
    queue = queue.then(migrate);
  }
  window.CallieLeeFavorites = {
    get: () => { try { return read().map(handleOf); } catch (_) { return []; } },
    refresh
  };
  window.CallieFavorites = {
    get: () => { try { return read(); } catch (_) { return []; } },
    has: handle => read().some(item => handleOf(item) === handle),
    add: product => {
      if (!product?.handle) return;
      const items = read();
      if (!items.some(item => handleOf(item) === product.handle)) save([product, ...items]);
    },
    remove: handle => save(read().filter(item => handleOf(item) !== handle)),
    toggle: product => {
      if (!product?.handle) return false;
      const active = read().some(item => handleOf(item) === product.handle);
      if (active) window.CallieFavorites.remove(product.handle);
      else window.CallieFavorites.add(product);
      return !active;
    },
    refresh
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
